var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-container"},[_c('div',{ref:"toolbar",staticClass:"editor-toolbar",attrs:{"hidden":_vm.isToolbarHidden}}),_c('div',{ref:"editor",staticClass:"editor-content"})])
}
var staticRenderFns = []

export { render, staticRenderFns }